// extracted by mini-css-extract-plugin
export default {"background":"modalBackdropForm_background__dhOoD","background-cover":"modalBackdropForm_background-cover__7yitK"};